/*
Copyright (c) 2012-2026 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved.
NOTICE: All information contained herein is, and remains the property of GRAB.
The intellectual and technical concepts contained herein are confidential,
proprietary and controlled by GRAB and may be covered by patents, patents in process,
and are protected by trade secret or copyright law.

You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate,
adapt or change this material in any way unless prior written permission is obtained from GRAB.
Access to the source code contained herein is hereby forbidden to anyone except current GRAB
employees or contractors with binding Confidentiality and Non-disclosure agreements explicitly
covering such access.

The copyright notice above does not evidence any actual or intended publication or disclosure of
this source code, which includes information that is confidential and/or proprietary,
and is a trade secret, of GRAB.

ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR
THROUGH USE OF THIS SOURCE CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED,
AND IN VIOLATION OF APPLICABLE LAWS AND INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS
SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS TO REPRODUCE,
DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT MAY DESCRIBE,
IN WHOLE OR IN PART.
*/
import { css } from "@emotion/core"
import { theme } from "styles/theme"

export const modalStyle = css`
  .ant-modal-footer button {
    display: inline;
  }
  .ant-modal-footer button:nth-of-type(1) {
    border: 1px solid transparent;
    border-color: #ccd6dd;
  }
  .ant-modal-footer {
    text-align: center;
    padding: 21px 16px;
    border-top: 1px solid #f5f5f5;
  }
  .ant-modal-header {
    border-bottom: 0;
    padding: 24px 24px 0;
  }
  .ant-modal-title {
    font-size: ${theme.fontSize.h2};
  }
  .ant-modal-body {
    color: #707070;
    padding-top: 4px;
  }
  .confirm-cancel-btn {
    color: #00a5cf;
  }
  .ant-modal-footer {
    border-top: none;
    padding: 0 24px 24px;
    .ant-btn-background-ghost {
      color: #00a5cf;
      &:hover,
      &:focus {
        background: rgba(0, 165, 207, 0.1) !important;
        border: 1px solid #00a5cf !important;
      }
    }
    button {
      height: unset;
      min-width: 160px;
    }
  }
`
export const modalFooterRightStyle = css`
  .ant-modal-footer {
    text-align: right;
  }
`
